import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import { prefersReducedMotion } from "../../util/motion";

const TYPE_DELAY = 95;
const DELETE_DELAY = 55;
const HOLD_DELAY = 2200;
const EMPTY_DELAY = 350;

const blink = keyframes`
  0%, 45% { opacity: 1; }
  50%, 95% { opacity: 0; }
  100% { opacity: 1; }
`;

const Wrapper = styled.span`
  white-space: nowrap;
`;

const Caret = styled.span`
  display: inline-block;
  width: 0.06em;
  height: 0.82em;
  margin-left: 0.06em;
  background: currentColor;
  vertical-align: -0.06em;
  animation: ${blink} 1s steps(1) infinite;
`;

// Types a word, holds, deletes it and moves on to the next one, forever.
// `words` should be a stable array (ex: defined outside the component using this).
function TypedWords(props) {
  const { words } = props;

  const [animate] = useState(() => !prefersReducedMotion());
  const [index, setIndex] = useState(0);
  const [length, setLength] = useState(words[0].length);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!animate) return;

    const word = words[index];
    const isFull = !deleting && length === word.length;
    const isEmpty = deleting && length === 0;

    let delay = deleting ? DELETE_DELAY : TYPE_DELAY;
    if (isFull) delay = HOLD_DELAY;
    if (isEmpty) delay = EMPTY_DELAY;

    const timeout = setTimeout(() => {
      if (isFull) {
        setDeleting(true);
      } else if (isEmpty) {
        setDeleting(false);
        setIndex((index + 1) % words.length);
      } else {
        setLength(length + (deleting ? -1 : 1));
      }
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [animate, words, index, length, deleting]);

  return (
    <Wrapper>
      {words[index].slice(0, length)}
      {animate && <Caret />}
    </Wrapper>
  );
}

export default TypedWords;
